export const links = {
  agroAprendiz: 'https://agroaprendiz.com.br',
  contactEmail: 'mailto:contato@aexionstudios.com.br',
} as const
